import { useState } from "react";
import { Link } from "react-router-dom";
import {
  Col,
  Flex,
  Image,
  Layout,
  Row,
  Space,
  Typography,
  Input,
  Button,
  Grid,
  message,
} from "antd";
import {
  PhoneOutlined,
  EnvironmentOutlined,
  LoadingOutlined,
} from "@ant-design/icons";

import facebookLogo from "../../../Images/Footer/facebook.png";
import instagramLogo from "../../../Images/Footer/instagram.png";
import tikTokLogo from "../../../Images/Footer/tiktok.png";
import telegramLogo from "../../../Images/Footer/telegram.png";

import sendLogo from "../../../Images/Footer/send.png";
import publicDataServices from "../../../APIs/publicDataServices";

const { Footer } = Layout;
const { Title, Text } = Typography;
const { useBreakpoint } = Grid;

const footerLinks = [
  { label: "Promotions", path: "/#promotion-section" },
  { label: "Products", path: "/products" },
  { label: "Catalogue", path: "/catalogues" },
  { label: "FAQ", path: "/faq" },
  { label: "About Us", path: "/company" },
  { label: "Contact Us", path: "/contact-us" },
  { label: "Corporate", path: "https://teamstarberhad.com/" },
];

const AppFooter = () => {
  const screens = useBreakpoint();

  const isMobile = !screens.md;

  const [email, setEmail] = useState("");

  const [loading, setLoading] = useState(false);

  const handleSubNewsletter = async () => {
    try {
      setLoading(true);

      const response = await publicDataServices.newsletterSub(email);

      // console.log("Newsletter subscription response:", response);

      if (response?.status !== 200) {
        message.error("Failed to subscribe to newsletter.");
      } else {
        message.success(response?.data?.message || "Subscribed to newsletter!");
      }

      setEmail("");
    } catch (error) {
      // console.error("Failed to subscribe to newsletter:", error);

      message.error(
        error?.response?.data?.message ||
          error?.response?.data ||
          "An error occurred. Please try again.",
      );
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  };

  return (
    <Footer
      style={{
        // backgroundColor: "#002753",
        backgroundColor: "#ffc20e",
        color: "white",
        paddingTop: "10px",
        paddingBottom: "30px",
        paddingLeft: "0px",
        paddingRight: "0px",
      }}
    >
      <div
        style={{
          marginLeft: isMobile ? "10%" : "5%",
          marginRight: isMobile ? "10%" : "5%",
        }}
      >
        <Row gutter={[32, 16]}>
          {/* About */}
          <Col xs={24} md={24} lg={7}>
            <Title level={5} style={{ color: "black", fontWeight: "bold" }}>
              About Teamstar
            </Title>

            <Text style={{ color: "#2e2e2eff" }}>
              Teamstar is a furniture hardware supplier in Malaysia offering
              cabinet hardware, kitchen accessories and storage solutions. From
              cabinet hinges, drawer systems and drawer slides to handles, knobs
              and cabinet and drawer locks, we help you find fittings for your
              furniture and renovation projects. Explore kitchen baskets, larder
              baskets and wardrobe accessories to organise your space.
            </Text>
          </Col>

          {/* Quick Links */}
          <Col xs={24} md={7} lg={4}>
            <Title level={5} style={{ color: "black", fontWeight: "bold" }}>
              Quick Links
            </Title>

            <Row>
              {footerLinks.map((link) => (
                <Col
                  xs={12}
                  sm={12}
                  md={24}
                  key={link.label}
                  style={{ marginBottom: 8 }}
                >
                  {link.path.startsWith("https://") ? (
                    <a href={link.path} style={{ color: "#2e2e2eff" }}>
                      {link.label}
                    </a>
                  ) : (
                    <Link to={link.path} style={{ color: "#2e2e2eff" }}>
                      {link.label}
                    </Link>
                  )}
                </Col>
              ))}
            </Row>
          </Col>

          {/* Contact Us */}
          <Col xs={24} md={7} lg={5}>
            <Title level={5} style={{ color: "black", fontWeight: "bold" }}>
              Contact Us
            </Title>

            <Space direction="vertical">
              <Text style={{ color: "#2e2e2eff" }}>
                <PhoneOutlined /> +60 12 250 6616
              </Text>

              {/* <Text style={{ color: "#2e2e2eff" }}>
                <MailOutlined /> info@teamstar.com
              </Text> */}

              <p style={{ color: "#2e2e2eff" }}>
                <Link to="/locate-us" style={{ color: "inherit" }}>
                  <EnvironmentOutlined /> Locations
                </Link>
              </p>
            </Space>
          </Col>

          {/* Newsletter */}
          <Col xs={24} md={8} lg={7}>
            <Title
              level={5}
              style={{ color: "black", fontWeight: "bold", marginTop: 20 }}
            >
              Newsletter
            </Title>

            <Space.Compact style={{ width: "100%" }}>
              <Input
                placeholder="Enter your email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={{
                  border: "1px solid #2e2e2eff",
                }}
              />

              <Button
                type="primary"
                style={{
                  width: 40,
                  backgroundColor: "#FFDC00",
                  border: "1px solid #2e2e2eff",
                }}
                onClick={handleSubNewsletter}
                disabled={loading || !email}
              >
                {!loading ? (
                  <Image
                    src={sendLogo}
                    preview={false}
                    style={{
                      width: 20,
                      height: 20,
                      marginTop: 6,
                      marginBottom: "auto",
                    }}
                  />
                ) : (
                  <LoadingOutlined
                    spin
                    style={{
                      color: "#002753",
                    }}
                  />
                )}
              </Button>
            </Space.Compact>
          </Col>

          {/* Social Icons */}
          <Col xs={24} style={{ marginTop: 10 }}>
            <Flex gap={8} align="center" wrap="wrap">
              <Image
                height={16}
                width={16}
                src={facebookLogo}
                preview={false}
                onClick={() =>
                  window.open(
                    "https://www.facebook.com/teamstar.com.my",
                    "_blank",
                  )
                }
                style={{ cursor: "pointer" }}
              />

              <Image
                height={16}
                width={16}
                src={instagramLogo}
                preview={false}
                onClick={() =>
                  window.open(
                    "https://www.instagram.com/tshardware88",
                    "_blank",
                  )
                }
                style={{ cursor: "pointer" }}
              />

              <Image
                height={16}
                width={16}
                src={tikTokLogo}
                preview={false}
                onClick={() =>
                  window.open(
                    "https://www.tiktok.com/@teamstarsolutions",
                    "_blank",
                  )
                }
                style={{ cursor: "pointer" }}
              />

              <Image
                height={16}
                width={16}
                src={telegramLogo}
                preview={false}
                onClick={() =>
                  window.open("https://t.me/+uUht24IFrFViMmM1", "_blank")
                }
                style={{ cursor: "pointer" }}
              />

              {/* Copyright */}
              <p
                style={{
                  color: "#2e2e2eff",
                  fontSize: 12,
                  marginTop: 10,
                }}
              >
                <b>
                  © {new Date().getFullYear()} 2026 Teamstar Solutions Sdn Bhd
                  200601028524 (748280-M). All Rights Reserved.
                </b>
              </p>
            </Flex>
          </Col>
        </Row>
      </div>
    </Footer>
  );
};

export default AppFooter;
